import { ExpenseReport } from "../models/expense_report";

export const downloadXML = (reports: ExpenseReport[], exportName: string) => {
  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
  xml += `<ExpenseReports exportFor="${exportName}">\n`;

  reports.forEach(r => {
    const date = r.expense_date ? new Date(r.expense_date).toISOString().split('T')[0] : "";
    const category = r.category?.item_type || "";
    
    const escapeXml = (unsafe: string) => unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
    
    const userFirstName = r.user?.first_name || "";
    const userLastName = r.user?.last_name || "";
    const actualEmployee = `${userFirstName} ${userLastName}`.trim() || exportName;

    const supplier = escapeXml(r.supplier_name || "");
    const description = escapeXml(r.comment || "");
    const amountTTC = Number(r.amount) || 0;
    const vatAmount = Number(r.vat_amount) || 0;
    const amountHT = amountTTC - vatAmount;
    const status = r.status || "";

    xml += `  <Expense>\n`;
    xml += `    <Date>${date}</Date>\n`;
    xml += `    <Employee>${escapeXml(actualEmployee)}</Employee>\n`; 
    xml += `    <Category>${category}</Category>\n`;
    xml += `    <Supplier>${supplier}</Supplier>\n`;
    xml += `    <Description>${description}</Description>\n`;
    xml += `    <AmountHT>${amountHT.toFixed(2)}</AmountHT>\n`;
    xml += `    <VATAmount>${vatAmount.toFixed(2)}</VATAmount>\n`;
    xml += `    <AmountTTC>${amountTTC.toFixed(2)}</AmountTTC>\n`;
    xml += `    <Status>${status}</Status>\n`;
    xml += `  </Expense>\n`;
  });

  xml += `</ExpenseReports>`;

  const blob = new Blob([xml], { type: 'application/xml;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.href = url;
  link.setAttribute('download', `export_${exportName.replace(/\s+/g, '_')}_${new Date().getTime()}.xml`);
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};